import React from 'react';
import Switch from 'react-switch';

export default props => {
  return (
    <Switch
      handleDiameter={20}
      offColor="#D2D2D2"
      onColor="#2D9542"
      offHandleColor="#545B72"
      onHandleColor="#FFFFFF"
      height={28}
      width={60}
      className="react-switch-input"
      {...props}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/shared/switch.js